import { CURRENCIES } from '../constants/currencies';

export const formatCurrency = (amount, currency = 'USD') => {
  const currencyInfo = CURRENCIES[currency];
  return `${currencyInfo.symbol}${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

export const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const formatDurationLong = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  if (mins === 0) return `${secs} sec`;
  if (secs === 0) return `${mins} min`;
  return `${mins} min ${secs} sec`;
};

export const formatDurationWithSeconds = (minutes) => {
  if (minutes < 1) return 'less than 1 minute';
  return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
};

export const formatDurationForDisplay = (minutes) => {
  if (minutes < 1) {
    // Show seconds if less than 1 minute
    const seconds = Math.round(minutes * 60);
    return `${seconds} second${seconds !== 1 ? 's' : ''}`;
  }
  const roundedMinutes = Math.round(minutes);
  return `${roundedMinutes} minute${roundedMinutes !== 1 ? 's' : ''}`;
};

export const formatDate = (isoString) => {
  const date = new Date(isoString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);
};